import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class XssValidationService {

  /**
   * Returns true if the string contains any script tags.
   * Uses DOMParser so the browser's own HTML engine handles all edge cases
   * that regex cannot (case variants, malformed tags, attribute injection, etc.).
   */
  containsScriptTag(value: string): boolean {
    if (!value) return false;
    const doc = new DOMParser().parseFromString(value, 'text/html');
    return doc.getElementsByTagName('script').length > 0;
  }

  /** Returns true if ANY of the provided values contains a script tag. */
  anyContainsScriptTag(...values: string[]): boolean {
    return values.some(v => this.containsScriptTag(v));
  }
}
